import React from "react";
import PropTypes from "prop-types";
import styles from './Chart.less';
import config from './../../config';

import { scaleTime } from "d3-scale";
import { format } from "d3-format";
import { timeFormat } from "d3-time-format";
import i18next from 'i18next';
import { ChartCanvas, Chart } from "react-stockcharts";
import {
    ScatterSeries,
    SquareMarker,
    TriangleMarker,
    CircleMarker,
    LineSeries,
} from "react-stockcharts/lib/series";
import { XAxis, YAxis } from "react-stockcharts/lib/axes";
import {
    CrossHairCursor,
    MouseCoordinateX,
    MouseCoordinateY,
} from "react-stockcharts/lib/coordinates";

import { HoverTooltip } from "react-stockcharts/lib/tooltip";
import { fitWidth } from "react-stockcharts/lib/helper";
import { last } from "react-stockcharts/lib/utils";
import CustomOHLCTooltip from './CustomOHLCTooltip';
import { connect } from 'react-redux';
import * as commonActions from './../../actions/commonActions';
@connect(
  state => ({
  selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
  language:state.dashboardRoot.commonReducer.language
}),
{ ...commonActions})

class HistoricalLineChart extends React.Component {
    componentDidMount() {
        this.node.subscribe("zoomlistner", { listener: this.handleEvents })
    }
    componentWillUnmount() {
        this.node.unsubscribe("zoomlistner")
    }
    handleEvents = (type, moreProps, state) => {
      try{
        if (type === "zoom" || type === "panend") {
            if (this.props.onZoomEvent) {
                this.props.onZoomEvent(moreProps.xScale.domain());
            }
        }
      }catch(e){
        this.props.logFileCreation({error:e.message, originFunction:'handleEvents', component:"HistoricalLineChart"});
      }
    }
    render() {
        const { data, type, width, ratio, dataType, durationType, decimals, mouseMoveEvent, panEvent, zoomEvent  } = this.props;


        const xAccessor = d => d && d.date ? d.date : '';
        // const start = xAccessor(data[0]);
        // const end = xAccessor(data[data.length - 1]);
        // const xExtents = [start , end];
        // const xExtents = [
        //   new Date(xAccessor(data[0]) - 1000*60*60*24),
        //   new Date(xAccessor(data[data.length - 1]) + 1000*60*60*24)
        // ];
        const xExtents = data.length > 4 ?  [ new Date(data[0].TradeDate-(86400000*3)), new Date(data[data.length - 1].TradeDate+(86400000*3)) ] : ( data.length === 4 ? [ new Date(data[0].TradeDate-(86400000*4)), new Date(data[data.length - 1].TradeDate+(86400000*4)) ] : [ new Date(data[0].TradeDate-(86400000*12)), new Date(data[data.length - 1].TradeDate+(86400000*12)) ] );
        var margin = {
          top: 20,
          right: 0,
          bottom: 45,
          left: 70
        };
        var dataLength = 0;
        if (this.props.data.length !== 0) {
          dataLength = Number(this.props.data[this.props.data.length-1].open).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}).length;
        }
        var height = (this.props.height > 400 ? this.props.height : 400 ) - margin.top - margin.bottom;
        var gridHeight = height - margin.top - margin.bottom;
        var gridWidth = width - 70;
        var color='#000';
        var axisColor='#000';
        var yGrid =  {
            innerTickSize: -1 * gridWidth,
            tickStrokeDasharray: 'Solid',
            tickStrokeOpacity: 0.2,
            tickStrokeWidth: 1,
            stroke: axisColor,
            tickStroke:color
        };
        var xGrid = {
            innerTickSize: -1 * gridHeight,
            tickStrokeDasharray: 'Solid',
            tickStrokeOpacity: 0.2,
            tickStrokeWidth: 1,
            stroke: axisColor,
            tickStroke:color
        } ;
        var yGridDark =  {
            innerTickSize: -1 * (width - 70),
            tickStrokeDasharray: 'Solid',
            tickStrokeOpacity: 0.3,
            tickStrokeWidth: 1,
            tickStroke:"#b2b1ae",
            stroke: "#b2b1ae"
        };
        var xGridDark = {
            innerTickSize: -1 * gridHeight,
            tickStrokeDasharray: 'Solid',
            tickStrokeOpacity: 0.3,
            tickStrokeWidth: 1,
            tickStroke:"#b2b1ae",
            stroke: "#b2b1ae"
        } ;
        let dateFormatter = d3.time.format("%M-%Y");
        const displayTextsZoom = {
          d: "D",
          o: "O",
          h: "H",
          l: "L",
          c: "C",
          v: "V",
          na: "n/a"
        };
        const displayTexts = {
          d: "Date",
          o: "O",
          h: "H",
          l: "L",
          c: "C",
          v: "V",
          na: "n/a"
        };
        let tickTimeFormat = d3.time.format.multi([
                  // [":%Ss", function(d) { return d.getSeconds(); }],
                  // ["%H:%M", function(d) { return d.getHours() || d.getMinutes(); }],
                  //["%d%b %Y", function(d) { return dateFormatter(new Date(d));}],
              //["%a %d", function(d) { return d.getDay() <= 6 && d.getDate() != 1; }],
               ["%d %b", function(d) { return true; }],
                  ["%d %b", function(d) { return d.getDate() != 1; }],
                  //["%b", function(d) { return d && true; }]
                  // ["%Y", function() { return true; }]
                ]);;
        var tickFormatFn = function(d) {
          //console.log(d);
            return tickTimeFormat(d);
        };
        var numberFormat = function(d) {
          return d.toLocaleString(navigator.language,{ minimumFractionDigits:decimals,maximumFractionDigits:decimals});
        }
        let tooltipContent = ({ currentItem }) => {
          if (this.props.language == 'AR') {
            return {
              x: (Number(currentItem.open).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals})) + ': '+i18next.t("O"),
              y: [{label: Number(currentItem.high).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}), value: i18next.t("H").split(':')[0]}, {label: Number(currentItem.low).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}), value: i18next.t("L").split(':')[0]}, {label: Number(currentItem.close).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}), value: i18next.t("C").split(':')[0]}]
              .filter(line => line.value)
            };
          }
          else {
            return {
              x: (i18next.t("open")) + ': '+Number(currentItem.open).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}),
              y: [{label: i18next.t("high").split(':')[0], value: '  '+Number(currentItem.high).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals})}, {label: i18next.t("low").split(':')[0], value: '   '+Number(currentItem.low).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals})}, {label: i18next.t("close").split(':')[0], value: Number(currentItem.close).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals})}]
              .filter(line => line.value)
            };
          }
        }

        let ohlcTooltipOrigin = [
            this.props.width< 517 ? -40 : (this.props.language != 'AR' ? 0 : 500),
            -38
          ];
        const zoomLevel = this.props.zoomLevel ? this.props.zoomLevel.map((item) => new Date(item)) : xExtents;
        return (
            <ChartCanvas ratio={ratio} width={width} height={height}
                    margin={margin}
                    seriesName="Line"
                    data={data}
                    xScale={scaleTime()}
                    xAccessor={xAccessor}
                    displayXAccessor={xAccessor}
                    ref={node => { this.node = node; } }
                    xExtents = {zoomLevel || xExtents}
                    //clamp={"both"}
                    pointsPerPxThreshold={0.5}
                    >
                        <Chart id={1}
                            yExtents={d => [d.close + Math.pow(10, -1 * (decimals-1)), d.close - Math.pow(10, -1 * (decimals-1))]}
                        >
                          { this.props.selectedCssColor === "DR" ?
                            <XAxis
                                axisAt="bottom"
                                orient="bottom"
                                ticks={data.length < 5 ? 4 : 5}
                                tickFormat={tickFormatFn}
                                {...xGridDark}
                            />
                            :
                            <XAxis
                                axisAt="bottom"
                                orient="bottom"
                                ticks={data.length < 5 ? 4 : 5}
                                tickFormat={tickFormatFn}
                                {...xGrid}
                            />
                          }
                          { this.props.selectedCssColor === "DR" ?
                            <YAxis
                                axisAt="left"
                                orient="left"
                                tickFormat={numberFormat}
                                {...yGridDark}
                                zoomEnabled={false}
                            />
                            :

                            <YAxis
                                axisAt="left"
                                orient="left"
                                tickFormat={numberFormat}
                                {...yGrid}
                                zoomEnabled={false}
                            />
                          }
                            <LineSeries
                                yAccessor={d => d.close}
                                strokeDasharray="Solid"
                                stroke={config.increaseRateColor}/>
                            <HoverTooltip
                              tooltipContent={tooltipContent}
                              fontSize={13}
                              bgfill={this.props.selectedThemes.tooltipHoverBg}
                              fill={this.props.selectedThemes.tooltipHoverBg}
                              fontFill={this.props.selectedThemes.tooltipHoverClr}
                              stroke={this.props.selectedThemes.tooltipHoverClr}
                            />
                            <CustomOHLCTooltip
                              forChart={1}
                              fontSize={13}
                              className={this.props.language != 'AR' ? `${styles.historicalToopTip}` : `${styles.historicalToopTip} chartTimeHead`}
                              origin={ohlcTooltipOrigin}
                              ohlcFormat={decimals}
                              displayTexts={this.props.width < 517 ? displayTextsZoom : displayTexts}
                              lastPointFromGraph={data[data.length-1]}
                              styleObj = {this.props.styleObj}
                            />
                        </Chart>
            </ChartCanvas>

        );
    }
}

HistoricalLineChart.propTypes = {
    data: PropTypes.array.isRequired,
    width: PropTypes.number.isRequired,
    ratio: PropTypes.number.isRequired,
    type: PropTypes.oneOf(["svg", "hybrid"]).isRequired,
    durationType: PropTypes.oneOf(['Day', 'Month', 'Quater', 'Half Year', 'Year']).isRequired,
    onZoomEvent: PropTypes.func,
    zoomLevel: PropTypes.array
};

HistoricalLineChart.defaultProps = {
    type: "svg"
};
HistoricalLineChart = fitWidth(HistoricalLineChart);

export default HistoricalLineChart;
